import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

export function Label({ className, ...props }: ComponentProps<"label">) {
  return <label data-slot="label" className={cn("font-sans text-sm leading-[1.4] font-semibold", className)} {...props} />;
}
